// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4495969c]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.title[data-v-4495969c]{font-size:30px}.info[data-v-4495969c]{font-size:16px}a[data-v-4495969c]{color:#0073f7;-webkit-text-decoration:none;text-decoration:none;text-decoration-color:inherited;text-decoration-color:initial;text-decoration-line:none;text-decoration-style:solid}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
